import React from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Sidebar = ({ isOpen, onClose, currentAgent, nickname, handleLogout }) => {
  const navigate = useNavigate();

  const changeAgent = (newAgent) => {
    Swal.fire({
      title: "🤖",
      text: "현재는 고등수학 에이전트만 사용 가능합니다",
      icon: "info",
      confirmButtonText: "알겠어요!",
      confirmButtonColor: "#7950F2",
      background: "#fff",
      width: "280px",
      padding: "10px",
      customClass: {
        popup: "rounded-2xl",
        title: "text-xl mb-2",
        content: "text-xs",
        confirmButton: "rounded-full px-4 py-1.5 text-xs font-medium",
      },
    });
  };

  const handleSidebarItemClick = (item) => {
    if (item === "학습 플랜") {
      navigate("/plan");
    } else if (item === "학습 대화") {
      navigate("/chat");
    } else if (item === "나의 책장") {
      navigate("/mybooks");
    }
    onClose();
  };

  const agentMenuItems = ["고등영어 에이전트", "고등국어 에이전트"];

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        />
      )}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="p-4 flex-1">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold">{currentAgent}</h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <button
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded-lg flex items-center"
                  onClick={() => handleSidebarItemClick("나의 책장")}
                >
                  <span className="mr-3">👤</span>
                  나의 책장
                </button>
                <div className="ml-8 mt-2 space-y-2">
                  {agentMenuItems.map((agent) => (
                    <button
                      key={agent}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      onClick={() => changeAgent(agent)}
                    >
                      {agent}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <p className="px-4 py-2">Chats</p>
                <div className="ml-8 mt-2 space-y-2">
                  <button
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded-lg text-gray-600"
                    onClick={() => handleSidebarItemClick("학습 대화")}
                  >
                    학습 대화
                  </button>
                  <button
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 rounded-lg text-gray-600"
                    onClick={() => handleSidebarItemClick("학습 플랜")}
                  >
                    학습 플랜
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 border-t">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-gray-200 rounded-full mr-3"></div>
                <div>
                  <div className="font-bold">{nickname}</div>
                  <div className="text-sm text-gray-600">학생</div>
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="text-sm text-red-500 hover:text-red-600"
              >
                로그아웃
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
